import Vue from 'vue';
import VueRouter from 'vue-router';
// import LandingView from '../views/Landing.vue';
// import DashboardView from '../views/Dashboard.vue';
// import ProjectsView from '../views/Projects.vue';
// eslint-disable-next-line import/extensions
import store from '../store/index.js';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'landing',
    component: () => import(/* webpackChunkName: "about" */ '../views/Landing.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.role === 'Superadmin') next('/administrator');
      else if (user.role === 'Country Manager') next('/country');
      else if (user.role === 'City Manager') next('/dashboard');
      else if (user.role === 'Project Site Manager') next('/dashboard');

      else next();
    },
  },
  {
    path: '/dashboard',
    name: 'global-dashboard',
    component: () => import(/* webpackChunkName: "about" */ '../views/GlobalDashboardV3.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // if (user.project_site_id !== '') {
      //   next(`site/${user.project_site_id}/dashboard`);
      // }
      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/dashboard/trends',
    name: 'dashboard-trends',
    component: () => import(/* webpackChunkName: "about" */ '../views/GlobalDashboardTrends.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // if (user.project_site_id !== '') {
      //   next(`site/${user.project_site_id}/dashboard`);
      // }
      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/dashboard/country-trends',
    name: 'country-dashboard-trends',
    component: () => import(/* webpackChunkName: "about" */ '../views/CountryDashboardTrends.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // if (user.project_site_id !== '') {
      //   next(`site/${user.project_site_id}/dashboard`);
      // }
      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/site/:id/dashboard',
    name: 'site-dashboard',
    component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // console.log('ROUTE', to.params.id);

      if (user.project_site_id === to.params.id) next();
      else if (user.role === 'Superadmin') next();
      else if (user.role === 'Country Manager') next('/country');

      else next('/');
    },
  },
  {
    path: '/site/:id/dashboard/trends',
    name: 'site-dashboard-trends',
    component: () => import(/* webpackChunkName: "about" */ '../views/DashboardTrendsV2.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // console.log('ROUTE', to.params.id);

      if (user.project_site_id === to.params.id) next();
      else if (user.role === 'Superadmin') next();
      else if (user.role === 'Country Manager') next('/country');

      else next('/');
    },
  },
  {
    path: '/site/:id/projects',
    name: 'projects',
    component: () => import(/* webpackChunkName: "about" */ '../views/Projects.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/site/:id/projects/create',
    name: 'create-project',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Project.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};
      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/site/:project_site_id/projects/project/:project_id',
    name: 'project',
    component: () => import(/* webpackChunkName: "about" */ '../views/Project.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/site/:project_site_id/projects/project/:project_id/history',
    name: 'project-history',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectHistory.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/site/:id/import',
    name: 'upload-excel',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ExcelUploadV2.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};
      if (user.uid) next();
      else next('/');
    },
  },

  {
    path: '/site/:id/baseline',
    name: 'baseline',
    component: () => import(/* webpackChunkName: "about" */ '../views/BaselineStudy.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.uid) next();
      else next('/');
    },
  },

  {
    path: '/framework-guidelines',
    name: 'framework-guidelines',
    component: () => import(/* webpackChunkName: "about" */ '../views/FrameworkGuidelines.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.uid) next();
      else next('/');
    },
  },

  {
    path: '/faqs',
    name: 'faqs',
    component: () => import(/* webpackChunkName: "about" */ '../views/FAQs.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/site/:id/project-site-info',
    name: 'project-site-info',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProjectSiteInformation.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.uid) next();
      else next('/');
    },
  },
  {
    path: '/administrator',
    name: 'administrator',
    component: () => import(/* webpackChunkName: "about" */ '../views/Administrator.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.role === 'Superadmin') next();
      else next('/');
    },
  },
  {
    path: '/administrator/countries',
    name: 'administrator-countries',
    component: () => import(/* webpackChunkName: "about" */ '../views/AdministratorCountries.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.role === 'Superadmin') next();
      else next('/');
    },
  },
  {
    path: '/administrator/cities',
    name: 'administrator-cities',
    component: () => import(/* webpackChunkName: "about" */ '../views/AdministratorCities.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.role === 'Superadmin') next();
      else next('/');
    },
  },
  {
    path: '/administrator/users',
    name: 'administrator-users',
    component: () => import(/* webpackChunkName: "about" */ '../views/AdministratorUsers.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.role === 'Superadmin') next();
      else next('/');
    },
  },
  {
    path: '/administrator/default-baselines',
    name: 'administrator-default-baselines',
    component: () => import(/* webpackChunkName: "about" */ '../views/AdministratorDefaultBaselines.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.role === 'Superadmin') next();
      else next('/');
    },
  },
  {
    path: '/administrator/data',
    name: 'administrator-data',
    component: () => import(/* webpackChunkName: "about" */ '../views/AdministratorData.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      if (user.role === 'Superadmin') next();
      else next('/');
    },
  },
  {
    path: '/goto',
    name: 'goto',
    component: () => import(/* webpackChunkName: "about" */ '../views/GoToCity.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // if (user.project_site_id !== '') {
      //   next(`site/${user.project_site_id}/dashboard`);
      // }
      if (user.uid) next();
      else next('/');
    },
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: 'about' */ '../views/AboutView.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
